import { scenarios } from '@/mocks/red-packet';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function Scenarios() {
  return (
    <section id="scenarios" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="应用场景"
          title="覆盖多元消费与惠民场景"
          subtitle="从政府惠民到企业营销，数字红包在不同场景下释放消费活力。"
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {scenarios.map((item, idx) => (
            <Reveal key={item.title} delay={idx * 80}>
              <div className="group h-full flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 transition-all duration-300 hover:-translate-y-1 hover:border-secondary-300">
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} - 数字红包解决方案`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 to-transparent"></div>
                  <div className="absolute bottom-3 left-4 flex items-center gap-2">
                    <div className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-500 text-foreground-950">
                      <i className={`${item.icon} text-lg`}></i>
                    </div>
                    <span className="text-sm font-semibold text-background-50">{item.title}</span>
                  </div>
                </div>
                <div className="flex-1 p-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}